import {defineStore} from 'pinia'
import api from '@/services/api'

export const useOrderLogsStore = defineStore('orderLogs', {
    state: () => ({
        orderIds: undefined,
        orders: {}
    }),
    actions: {
        async fetchOrderIds() {
            if (this.orderIds === undefined) {
                this.orderIds = []
                
                const {data: {values}} = await api.get('api/component/order_log/orderId', {
                    params: {groupBy: 'orderId'}
                })
                
                this.orderIds = values
            }
            
            return this.orderIds
        },
        async getOrderLogs(orderId) {
            if (this.orders[orderId]) {
                return this.orders[orderId]
            } else {
                const {data: {items}} = await api.get('api/component/order_log', {
                    params: {
                        orderId,
                        sort: '-id'
                    }
                })
                
                this.orders[orderId] = items
                
                return items
            }
        }
    }
})